export enum placeholderTypes {
  Product,
  Image,
  Divider,
  Blank,
  CropDivider,
  TOC,
  BlankPage,
  TechSheet,
  Seed,
  SeedDivider,
  Agronomy,
}
export function isRightPageOnlyPlaceholderType(p: placeholderTypes): Boolean {
  return (p === placeholderTypes.Divider
      || p === placeholderTypes.CropDivider
      || p === placeholderTypes.SeedDivider);
}




// WEBPACK FOOTER //
// ./src/infrastructure/placeholderTypes.ts